import { EStatus } from '../../../repositories/cpd/entities/v1_get_referrals_listing/ReferralItem';
import { IconFunctionalErrorCircle16, IconFunctionalSuccessCircle16, UIHeading4 } from '@cian/ui-kit';
import { IconFunctionalClock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IStatus {
  name: React.ReactNode;
  icon: React.ReactNode;
  modalContent: {
    title: string;
    description: string;
    btnTxt: string;
  };
}

interface IStatusMapper {
  [key: string]: IStatus;
}

export const STATUS_MAPPER: IStatusMapper = {
  [EStatus.Paid]: {
    name: <UIHeading4 color="text-positive-default">Деньги получены</UIHeading4>,
    icon: <IconFunctionalSuccessCircle16 color="icon-positive-default" />,
    modalContent: {
      title: '+ 10 000 ₽',
      description: 'Перечислили вам вознаграждение. Рекомендуйте Сделку и зарабатывайте ещё больше!',
      btnTxt: 'Спасибо',
    },
  },
  [EStatus.Completed]: {
    name: <UIHeading4 color="text-main-default">Сделка завершилась</UIHeading4>,
    icon: <IconFunctionalClock16 color="icon-main-default" />,
    modalContent: {
      title: 'Сделка завершилась',
      description:
        'Ура, рекомендация сработала! Теперь вознаграждение ваше — чтобы его получить, дождитесь от нас смс с инструкцией.',
      btnTxt: 'Отлично, жду смс!',
    },
  },
  [EStatus.Rejected]: {
    name: <UIHeading4 color="text-primary-default">Отказ от программы</UIHeading4>,
    icon: <IconFunctionalErrorCircle16 color="icon-primary-default" />,
    modalContent: {
      title: 'Отказ от участия в Сделке',
      description: 'Такое тоже бывает — не подошли друг другу. Попробуйте позвать кого‑нибудь ещё.',
      btnTxt: 'Понятно',
    },
  },
  [EStatus.InProgram]: {
    name: <UIHeading4 color="text-main-default">В программе</UIHeading4>,
    icon: <IconFunctionalClock16 color="icon-main-default" />,
    modalContent: {
      title: 'В Сделке',
      description:
        'Начали работать вместе по вашей рекомендации. Поможем решить вопрос с недвижимостью и выплатим вам вознаграждение, как всё будет готово.',
      btnTxt: 'Понятно',
    },
  },
};
